import React from 'react';
import { Link } from 'react-router-dom';
import CanonicalURL from '../components/CanonicalURL';
import ContactFormBox from '../components/ContactFormBox';
import './HelpPage.css';

const TermsPage = () => {
  return (
    <>
      <CanonicalURL url="https://wealthcore.app/terms" />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="text-blue-600 hover:underline text-sm mb-6 inline-block">← Back to Home</Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
          <p className="text-gray-500 text-sm mb-8">Last updated: February 2026</p>

          <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">1. Acceptance of Terms</h2>
              <p>By accessing or using WealthCore (&quot;the Service&quot;), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">2. No Professional Advice</h2>
              <p><strong>WealthCore is not a registered investment advisor, broker-dealer, CPA, tax attorney, or licensed financial professional.</strong> All content, tools, calculations, and features—including tax optimization, stock analysis, real estate management, and retirement planning—are provided for educational and informational purposes only. Nothing on the Service constitutes:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Investment advice or a recommendation to buy or sell any security</li>
                <li>Tax advice or professional tax preparation</li>
                <li>Legal advice</li>
                <li>Financial planning advice</li>
              </ul>
              <p className="mt-2">You are solely responsible for your financial decisions. Consult qualified professionals (CPA, tax attorney, financial advisor) before acting on any information.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">3. No Warranties</h2>
              <p>The Service is provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind, express or implied. We do not warrant that calculations, data, or content are accurate, complete, or current. Tax laws and market conditions change; we do not guarantee results.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">4. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, WealthCore and its operators shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, goodwill, or investment losses, arising from your use of the Service. Our total liability shall not exceed the amount you paid to us in the twelve months preceding the claim, or $100, whichever is greater. You acknowledge that you use the Service at your own risk.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">5. Indemnification</h2>
              <p>You agree to indemnify, defend, and hold harmless WealthCore and its operators from any claims, damages, losses, or expenses (including reasonable attorneys&apos; fees) arising from your use of the Service, your violation of these Terms, or your violation of any third-party rights.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">6. User Responsibility</h2>
              <p>You are responsible for the accuracy of data you enter, for maintaining the security of your account, and for all activity under your account. You agree to use the Service only for lawful purposes and in compliance with applicable laws.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">7. Data and Privacy</h2>
              <p>Your use of the Service is also governed by our <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link>. By using the Service, you consent to the collection and use of information as described therein.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">8. Modifications</h2>
              <p>We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance. We encourage you to review these Terms periodically.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">9. Governing Law</h2>
              <p>These Terms shall be governed by the laws of the United States and the State of Delaware, without regard to conflict of law principles. Any disputes shall be resolved in the courts of competent jurisdiction.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">10. Contact</h2>
              <p>Questions about these Terms? Use the form below or contact us at <Link to="/help#contact-form" className="text-blue-600 hover:underline">support@wealthcore.app</Link>.</p>
            </section>
          </div>

          {/* Terms of Service Contact Form */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <ContactFormBox
              title="Terms of Service Questions"
              subtitle="Have a question about our Terms of Service? Send us a message and we'll get back to you within 24 hours."
              fixedSubject="Terms of Service"
            />
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link to="/" className="text-blue-600 hover:underline">← Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPage;
